import {
	ComponentRef,
	Directive,
	Input,
	TemplateRef,
	ViewContainerRef,
	ViewRef,
} from '@angular/core';
import { SpinWhileComponent } from './spin-while.component';

// Context
export class SpinUntilDirectiveContext<T> {
	public $implicit: T = null;
	public aeSpinUntil: T = null;
}

// Directive
@Directive({
	selector: '[aeSpinUntil]',
})
export class SpinUntilDirective<T> {
	private _spinClass = 'fa-3x';
	private _alignmentClass = 'text-center my-4';
	private _spinMessage = '';

	private _context: SpinUntilDirectiveContext<T> =
		new SpinUntilDirectiveContext<T>();
	private _spinWhileComponent: ComponentRef<SpinWhileComponent>;
	private _viewRef: ViewRef;

	@Input() public set aeSpinUntil(condition: T) {
		this._context.$implicit = this._context.aeSpinUntil = condition;
		this.refreshView();
	}

	@Input() public set aeSpinUntilSpinClass(spinClass: string) {
		this._spinClass = spinClass;
		if (this._spinWhileComponent) {
			this._spinWhileComponent.instance.spinClass = this._spinClass;
		}
	}

	@Input() public set aeSpinUntilAlignmentClass(alignmentClass: string) {
		this._alignmentClass = alignmentClass;
		if (this._spinWhileComponent) {
			this._spinWhileComponent.instance.alignmentClass = this._alignmentClass;
		}
	}

	@Input() public set aeSpinUntilSpinMessage(spinMessage: string) {
		this._spinMessage = spinMessage;
		if (this._spinWhileComponent) {
			this._spinWhileComponent.instance.spinMessage = this._spinMessage;
		}
	}

	@Input() public set aeSpinUntilInline(inline: boolean) {
		if (inline) {
			this.aeSpinUntilSpinClass = 'fa-1x';
			this.aeSpinUntilAlignmentClass = '';
		}
	}

	constructor(
		private _viewContainer: ViewContainerRef,
		private _templateRef: TemplateRef<any>,
	) {}

	private refreshView = () => {
		if (this._context.$implicit) {
			if (this._viewRef == null) {
				this._viewContainer.clear();

				this._spinWhileComponent = null;
				this._viewRef = this._viewContainer.createEmbeddedView(
					this._templateRef,
					this._context,
				);
			}
		} else {
			if (this._spinWhileComponent == null) {
				this._viewContainer.clear();

				this._viewRef = null;
				this._spinWhileComponent =
					this._viewContainer.createComponent(SpinWhileComponent);

				if (this._spinClass != null) {
					this._spinWhileComponent.instance.spinClass = this._spinClass;
				}
				if (this._alignmentClass != null) {
					this._spinWhileComponent.instance.alignmentClass =
						this._alignmentClass;
				}
				if (this._spinMessage != null) {
					this._spinWhileComponent.instance.spinMessage = this._spinMessage;
				}
			}
		}
	};
}
